<script>
import { mapState } from 'vuex';

export default {
    computed: {
    ...mapState('filters', [
      'filtersOptions',
    ]),
  },
  methods: {
    isImageFile(file) {
      return !file.removed && ['jpg', 'png', 'jpeg', 'svg'].includes(this.getFileFormat(file));
    },
    getFileFormat(file) {
      return file.filename.substr(file.filename.lastIndexOf('.') + 1).toLowerCase();
    },
  },
};
</script>
